import { useTranslation } from "react-i18next";
import { useBasicComponents } from "./useBasicComponent";

export const useVIAConfig = (action = "create", defaultValues = {}) => {
  const { t } = useTranslation();
  const {
    replicas,
    replicasReadOnly,
    core,
    memory,
    version,
    dataDisk,
    javaOpts,
  } = useBasicComponents(action, defaultValues);

  const viaDSColumns = () => {
    const group = "via-ds";
    return [
      replicas({ group }),
      core({ group }),
      memory({ group }),
      version({ group }),
      dataDisk({ group }),
      javaOpts(group),
    ];
  };

  const viaRSColumns = () => {
    const group = "via-rs";
    return [
      replicas({ group }),
      core({ group }),
      memory({ group }),
      version({ group }),
      dataDisk({ group }),
      javaOpts(group),
    ];
  };

  const viaPSColumns = () => {
    const group = "via-ps";
    return [
      replicas({ group }),
      core({ group }),
      memory({ group }),
      version({ group }),
      dataDisk({ group }),
      javaOpts(group),
    ];
  };

  const viaFSColumns = () => {
    const group = "via-fs";
    return [
      replicas({ group }),
      core({ group }),
      memory({ group }),
      version({ group }),
      dataDisk({ group }),
      javaOpts(group),
    ];
  };

  const viaAllColumns = () => {
    const group = "via-all";
    return [
      replicas({ group }),
      core({ group }),
      memory({ group }),
      version({ group }),
      dataDisk({ group }),
      javaOpts(group),
    ];
  };

  const viaSchema = [
    {
      title: t("config.instance.form.viads", "VIA DS"),
      valueType: "group",
      columns: viaDSColumns(),
    },
    {
      title: t("config.instance.form.viars", "VIA RS"),
      valueType: "group",
      columns: viaRSColumns(),
    },
    {
      title: t("config.instance.form.viaps", "VIA PS"),
      valueType: "group",
      columns: viaPSColumns(),
    },
    {
      title: t("config.instance.form.viafs", "VIA FS"),
      valueType: "group",
      columns: viaFSColumns(),
    },
    {
      title: t("config.instance.form.viafs", "VIA All-in-One (Non-HA)"),
      valueType: "group",
      columns: viaAllColumns(),
    },
  ];

  return viaSchema;
};
